export default function normalizeKey(key) {
  // Cast the key to a string, as that's all we can set as a key.
  if (typeof key !== 'string') {
    console.warn("".concat(key, " used as a key, but it is not a string."));
    key = String(key);
  }

  return key;
}